import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=5aed8113"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aed8113')) {
      api.createRecord('5aed8113', component.options)
    } else {
      api.reload('5aed8113', component.options)
    }
    module.hot.accept("./ExchangeRate.vue?vue&type=template&id=5aed8113", function () {
      api.rerender('5aed8113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/ExchangeRate.vue"
export default component.exports